var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounEnjoyment4065784(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.605,
    height: 115.61,
    viewBox: "0 0 115.605 115.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-enjoyment-4065784",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M240.829,79.159a30.828,30.828,0,1,0-21.8-9.029A30.832,30.832,0,0,0,240.829,79.159Zm-10.4-42.39a29.057,29.057,0,0,0,20.81,0A56.533,56.533,0,0,1,252.39,46.4H229.268A56.527,56.527,0,0,1,230.424,36.768ZM252.39,50.256a56.587,56.587,0,0,1-1.117,9.634,30.828,30.828,0,0,0-20.81,0,56.563,56.563,0,0,1-1.195-9.634ZM232.043,73.8a26.808,26.808,0,0,1-9-5.241,24.9,24.9,0,0,1,4.817-3.391A30.245,30.245,0,0,0,232.043,73.8Zm-.636-10.231h0a26.983,26.983,0,0,1,18.845,0C248,70.855,244.3,75.306,240.829,75.306s-7.168-4.451-9.423-11.735Zm22.391,1.6h0a24.909,24.909,0,0,1,4.817,3.391,26.816,26.816,0,0,1-9,5.241,30.247,30.247,0,0,0,4.181-8.632Zm1.041-3.854h0a59.725,59.725,0,0,0,1.406-11.06h11.561a26.839,26.839,0,0,1-6.377,15.569,30.316,30.316,0,0,0-6.59-4.451ZM256.245,46.4a59.781,59.781,0,0,0-1.368-11.118,30.313,30.313,0,0,0,6.493-4.451A26.84,26.84,0,0,1,267.806,46.4ZM253.8,31.489a30.246,30.246,0,0,0-4.181-8.632,26.808,26.808,0,0,1,9,5.241A24.905,24.905,0,0,1,253.8,31.489Zm-3.546,1.6h0a26.983,26.983,0,0,1-18.845,0c2.255-7.284,5.954-11.735,9.423-11.735s7.168,4.451,9.423,11.735Zm-22.389-1.6a24.907,24.907,0,0,1-4.817-3.391,26.815,26.815,0,0,1,9-5.241A30.247,30.247,0,0,0,227.863,31.489Zm-1.041,3.854a59.725,59.725,0,0,0-1.406,11.06H213.855a26.839,26.839,0,0,1,6.377-15.569,30.317,30.317,0,0,0,6.59,4.451Zm-1.406,14.914a59.778,59.778,0,0,0,1.368,11.118,30.313,30.313,0,0,0-6.493,4.451,26.832,26.832,0,0,1-6.34-15.569Z",
    transform: "translate(-183.028 -17.5)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M320.622,326.561a11.56,11.56,0,1,0-3.386,8.175A11.563,11.563,0,0,0,320.622,326.561Zm-19.268,0a7.706,7.706,0,1,1,2.257,5.45A7.71,7.71,0,0,1,301.354,326.561Z",
    transform: "translate(-251.259 -249.488)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M257.076,377.644l9.4-35.183a7.645,7.645,0,0,0-14.663-4.278l-5.9,17.766h-23.93l-5.9-17.842h0a7.652,7.652,0,0,0-14.663,4.354l9.4,35.183a1.926,1.926,0,0,0,1.927,1.426h42.39a1.926,1.926,0,0,0,1.927-1.426Zm-42.833-2.427-9.076-33.758a3.8,3.8,0,0,1,7.284-2.158l6.32,19.268a1.926,1.926,0,0,0,1.831,1.33h26.7a1.927,1.927,0,0,0,1.927-1.33l6.32-19.268a3.854,3.854,0,0,1,7.284,2.139l-9.172,33.778Z",
    transform: "translate(-176.152 -263.462)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M93.158,236.055l-1.195,7.4A1.935,1.935,0,0,0,94.8,245.5l6.2-3.487,6.2,3.449h0a2.06,2.06,0,0,0,.944.231,1.924,1.924,0,0,0,1.889-2.273l-1.195-7.361,5.106-5.241a1.925,1.925,0,0,0-1.1-3.237l-6.975-1.156-3.122-6.59a1.926,1.926,0,0,0-3.506,0l-3.122,6.59-6.975,1.06a1.925,1.925,0,0,0-1.1,3.237Zm4.567-5.9a1.927,1.927,0,0,0,1.445-1.08l1.83-3.854,1.83,3.854a1.927,1.927,0,0,0,1.445,1.08l4.3.655-3.179,3.314a1.929,1.929,0,0,0-.52,1.657l.732,4.451-3.68-2.1a1.927,1.927,0,0,0-1.927,0l-3.6,2.023.752-4.451a1.927,1.927,0,0,0-.539-1.58l-3.179-3.314Z",
    transform: "translate(-87.515 -174.396)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M495.658,235.781l-1.195,7.4a1.935,1.935,0,0,0,2.833,2.042l6.2-3.487,6.2,3.449h0a2.059,2.059,0,0,0,.944.231,1.924,1.924,0,0,0,1.889-2.273l-1.195-7.361,5.106-5.241a1.925,1.925,0,0,0-1.1-3.237l-6.975-1.156-3.122-6.666a1.926,1.926,0,0,0-3.506,0l-3.122,6.666-6.975,1.06a1.925,1.925,0,0,0-1.1,3.237Zm4.567-5.9a1.927,1.927,0,0,0,1.445-1.08l1.927-3.854,1.927,3.854a1.927,1.927,0,0,0,1.445,1.08l4.3.655-3.372,3.314a1.929,1.929,0,0,0-.52,1.657l.732,4.451-3.68-2.023h0a1.927,1.927,0,0,0-1.927,0l-3.68,2.023.828-4.528a1.927,1.927,0,0,0-.52-1.658l-3.179-3.237Z",
    transform: "translate(-401.381 -174.123)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M140,113.75h3.854v7.707H140Z",
    transform: "translate(-128.442 -92.555)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M140,166.25h3.854v7.707H140Z",
    transform: "translate(-128.442 -133.494)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M157.5,148.75h7.707V152.6H157.5Z",
    transform: "translate(-142.089 -119.848)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M105,148.75h7.707V152.6H105Z",
    transform: "translate(-101.15 -119.848)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M542.5,113.75h3.854v7.707H542.5Z",
    transform: "translate(-442.308 -92.555)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M542.5,166.25h3.854v7.707H542.5Z",
    transform: "translate(-442.308 -133.494)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M560,148.75h7.707V152.6H560Z",
    transform: "translate(-455.955 -119.848)",
    fill: "#0f8a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M507.5,148.75h7.707V152.6H507.5Z",
    transform: "translate(-415.015 -119.848)",
    fill: "#0f8a45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounEnjoyment4065784);
export default __webpack_public_path__ + "static/media/noun-enjoyment-4065784.b12c40531d6f02bfc390f667fa8a0a5f.svg";
export { ForwardRef as ReactComponent };